class Newsletter extends HTMLElement {
    constructor() {
      super();
  
      this.button = this.querySelector("#notify_me");
      this.email = this.querySelector("#notify_email");
      this.privacyCheck = this.querySelector("#inputCheckbox");
      this.successMessage = this.querySelector("#ContactFooter-success");
      this.errorMessage = this.querySelector("#ContactFooter-error");
      this.listId = this.dataset.id;
  
      this.addEvents();
    }
  
    addEvents() {
      this.button.addEventListener("click", (event) => {
        event.preventDefault();
  
        // Pulisce i messaggi esistenti
        this.clearMessages();
  
        // Verifica validità del form
        if (this.email.checkValidity() && this.privacyCheck.checkValidity()) {
          if (this.validateEmail()) {
            this.subscribeToNewsletter();
          }
        } else {
          // Mostra errori di validazione del browser
          this.email.reportValidity();
          this.privacyCheck.reportValidity();
        }
      });
    }
  
    validateEmail() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(this.email.value.trim())) {
        this.errorMessage.classList.remove("tw-hidden");
        return false;
      }
      return true;
    }
  
    clearMessages() {
      // Nasconde messaggi di successo ed errore
      this.successMessage.classList.add("tw-hidden");
      this.errorMessage.classList.add("tw-hidden");
    }
  
    async subscribeToNewsletter() {
      const data = new URLSearchParams({
        g: this.listId,
        email: this.email.value.trim(),
      });
  
      try {
        const response = await fetch("https://manage.kmail-lists.com/ajax/subscriptions/subscribe", {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: data,
        });
  
        const result = await response.json();
  
        if (result.success) {
          this.showSuccess();
          window.Shopify.analytics.publish('newsletter_subscription', {
            url: window.location.href
          });
        } else {
          this.errorMessage.classList.remove("tw-hidden");
        }
      } catch (error) {
        console.error("Errore di rete:", error);
        this.errorMessage.classList.remove("tw-hidden");
      }
    }
  
    showSuccess() {
      // Mostra il messaggio di successo e resetta il form
      this.successMessage.classList.remove("tw-hidden");
      this.email.value = "";
      this.privacyCheck.checked = false;
    }
  }
  
  customElements.define("custom-newsletter", Newsletter);
  